import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { DhContabilidadConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

const ImporteDebeFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, handleChange }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevoValor = e.target.value
      if (!nuevoValor) {
        setFieldValue('dh', '')
      } else {
        setFieldValue('dh', DhContabilidadConstant.DEBE)
      }
      setFieldValue('importeHaber', '')
    },
    [handleChange, setFieldValue]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-modalavanz-importeHaber', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='IMPORTE DEBE' htmlFor='input-modalavanz-importeDebe' md={12} />
      <Col md={12}>
        <Field name='importeDebe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-modalavanz-importeDebe'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteDebeFormGroup)
